module.exports = __webpack_public_path__ + "img/map-and-contact-white-all.ab0acbca.png";